import script from "./setTask.vue?vue&type=script&setup=true&lang=js"
export * from "./setTask.vue?vue&type=script&setup=true&lang=js"

import "./setTask.vue?vue&type=style&index=0&id=0fee562e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fee562e"]])

export default __exports__